<template>
  <div class="ListeInventaire">
    <div class="container">
      <div class="inventaires">
        <div v-if="loggedInRole=='admin' || loggedInRole=='gestion'" class="links linksInventaire">
          <a class="download" @click="downloadDatasInventaires"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-arrow-down-fill" viewBox="0 0 16 16">
          <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zm-1 4v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 11.293V7.5a.5.5 0 0 1 1 0z"/>
          </svg>Exporter vers CSV</a>
          <a class="download" @click="deleteDatasInventaires"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-arrow-down-fill" viewBox="0 0 16 16">
            <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zm-1 4v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 11.293V7.5a.5.5 0 0 1 1 0z"/>
            </svg>Supprimer les inventaires</a>
        </div>
        <h2>Liste des derniers inventaires</h2>
        
        <div class="last-inventaires">
          <div class="row">
            <div class="col-lg-6"  v-for="inventaire in inventaires" :key="inventaire.id">
              <RouterLink :to="'/inventaire-recap/' + inventaire.id + '/' + inventaire.date_inventaire.replace(/ /g, '-').replace(/\//g, '-').replace(/:/g, '-') + '/' + inventaire.nom + '/' + inventaire.prenom" class="inventaireCard">
                <h3>{{ inventaire.nom }} {{ inventaire.prenom }}</h3>
                <p>({{ inventaire.date_inventaire }})</p>
              </RouterLink>
            </div>
          </div>
       
       
        </div>

        <div v-if="confirmationMessage" class="alert alert-success" role="alert">
          {{ confirmationMessage }}
        </div>
        <div v-if="errorMessage" class="alert alert-danger" role="alert">
          {{ errorMessage }}
        </div>
        <button class="ajout-inventaire" @click="toggleAdd"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-circle-fill" viewBox="0 0 16 16">
        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z"/>
        </svg>Ajouter ou mettre à jour un inventaire</button>


        <div class="encart">
          <div class="add" v-if="afficherAdd">
            <div class="entete">
              <h3>Veuillez entrez vos quantités dans les champs prévus à cet effet</h3>
              <p class="petit">Dans un souci d'expérience utilisateur, veuillez scroller pour faire apparaitre la suite du tableau</p>
              <div class="searchInventaire">
                <input @input="searchArticles()" v-model="searchTerm" type="text" placeholder="Rechercher un article...">
                <select v-if="loggedInRole !== 'client' && loggedInRole !== 'magasin'" @change="searchArticles()"  v-model="selectedMag">
                  <option value="">Tous les magasins</option>
                  <option v-for="magasin in magasins" :key="magasin.id" :value="magasin.id_magasins">{{ magasin.nom_magasins }}</option>
                </select>
                <select v-if="loggedInRole !== 'client' && loggedInRole !== 'magasin'" @change="searchArticles()" v-model="selectedFourn">
                  <option value="">Tous les fournisseurs</option>
                  <option v-for="fournisseur in fournisseurs" :key="fournisseur.id" :value="fournisseur.cofou">{{ fournisseur.nom }}</option>
                </select>
              </div>
            </div>
            <table class="articlesListe inventaireListe">
              <thead>
                <tr>
                  <th>Code</th>
                  <th>Désignation 1</th>
                  <th>Désignation 2</th>
                  <th>Désignation 3</th>
                  <th>Fournisseur</th>
                  <th>Quantité</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(article, index) in articles" :key="article.id" :value="article.coarti" :class="index % 2 === 0 ? 'ligne-claire' : 'ligne-foncee'">
                  <td>{{ article.coarti }}</td>
                  <td>{{ article.desa1 }}</td>
                  <td>{{ article.desa2 }}</td>
                  <td>{{ article.desa3 }}</td>
                  <td>{{ article.fourn }}</td>
                  <td><input type="number" v-model="article.saisie" :placeholder="article.quantite" @input="updateQuantity(article.coarti, article.saisie)" /></td>
                </tr>
              </tbody>
              
            </table>
            <button @click="validerInventaire">Valider l'inventaire</button>
          </div>
          <div v-if="!afficherAdd">
            <p class="petit">Cliquer sur <strong>+ Ajouter un inventaire</strong> pour faire apparaitre le tableau</p>
          </div>
        </div>
      </div>
    </div>
    <!-- Loader -->
    <div v-if="isLoading" class="loader">
      <div id="loading"></div>
    </div>
  </div>
</template>

<script>
import axios from '@/components/axiosConfig.js'
import VueCookies from 'vue-cookies'



export default {
  data() {
    return {
      inventaires: [],
      articles: [],
      fournisseurs: [],
      magasins: [],
      loggedInEmail: '',
      loggedInRole: '',
      searchTerm: '',
      confirmationMessage: '',
      errorMessage: '',
      selectedMag: '',
      selectedFourn: '',
      afficherAdd: false,
      isLoading: false,
      quantities: {}, // Ajoutez cette ligne
    }
  },
  created() {
    
    
    
    const email = VueCookies.get('email')
    if (email) {
      this.loggedInEmail = email
    }
    const role = VueCookies.get('role')
    if (role) {
      this.loggedInRole = role
    }
  
    
   

  },
  mounted() { 

    this.getInventaire();

    this.searchArticles();

    axios.get('https://www.simef.fr/espace-client/api/getMagasinsArticles.php')
    .then(response => {
      this.magasins = response.data;
    })
    .catch(error => {
      console.error(error);
      
    });

    axios.get('https://www.simef.fr/espace-client/api/getFournisseurs.php')
    .then(response => {
      this.fournisseurs = response.data;
    })
    .catch(error => {
      console.error(error);
      
    });

  }, 
  methods: {

    validerInventaire() {
      // Filtrer les articles avec des valeurs de saisie non vides
      const dataToSend = this.articles
        .filter(article => article.saisie !== '')
        .map(article => ({
          coarti: article.coarti,
          qte: article.qte,
          saisie: article.saisie
        }));
      
      this.isLoading = true; // Afficher le loader

      axios.post('https://www.simef.fr/espace-client/api/enregistrerInventaire.php', {
        utilisateur: this.loggedInEmail,
        inventaire: dataToSend
      })
      .then(response => {
        this.confirmationMessage = response.data.success;
        this.errorMessage = response.data.error;
        this.getInventaire();
      })
      .catch(error => {
        console.error(error);
      })
      .finally(() => {
        this.isLoading = false; // Cacher le loader
      });
    },
    toggleAdd() {
      this.afficherAdd = !this.afficherAdd;
    },
    updateQuantity(coarti, saisie) {
      this.quantities[coarti] = saisie;
    },
    getInventaire() {
      // Envoyer les données du chantier au serveur
      axios.post('https://www.simef.fr/espace-client/api/getInventaires.php', {
        utilisateur: this.loggedInEmail,
        role: this.loggedInRole
      })
      .then(response => {
          this.inventaires = response.data;
      })
      .catch(error => {
          console.error(error);
          this.refusMessage = "Une erreur est survenue";
      });
    },
    downloadDatasInventaires() {
      this.isLoading = true; // Show loader
      axios.post('https://www.simef.fr/espace-client/api/downloadDatasInventaires.php', {
       
      })
      .then(response => {
             // Récupérer le lien retourné par le backend
             const lienTelechargement = response.data.lien;
            // Télécharger le fichier en ouvrant le lien dans une nouvelle fenêtre ou un nouvel onglet
            window.open(lienTelechargement, '_blank');
      })
      .catch(error => {
          console.log(error);
      })  
      .finally(() => {
        this.isLoading = false; // Hide loader
      });
    },
    searchArticles() {
      axios.post('https://www.simef.fr/espace-client/api/getAllArticles.php', {
        searchTerm: this.searchTerm,
        selectedMag: this.selectedMag,
        selectedFourn: this.selectedFourn,
        email: this.loggedInEmail,
      })
      .then(response => {
        const newArticles = response.data;
        // Pour chaque article trouvé, conservez la quantité saisie si elle existe déjà
        newArticles.forEach(article => {
          const existingQuantity = this.quantities[article.coarti];
          article.saisie = existingQuantity ? existingQuantity : '';
        });

        this.articles = newArticles;
      })
      .catch(error => {
        console.error(error);
      });
    },
    deleteDatasInventaires() {
      const confirmation = confirm("Êtes vous sur de vouloir supprimer ce fichier ?");
      this.isLoading = true; // Show loader
      if (confirmation) {
        axios.post('https://www.simef.fr/espace-client/api/deleteInventaire.php', {
        
        })
        .then(response => {
          this.confirmationMessage = response.data.success;
          this.errorMessage = response.data.error;
        })
        .catch(error => {
            console.log(error);
        })  
        .finally(() => {
          this.getInventaire();
          this.isLoading = false; // Hide loader
        });
      }
    },
        
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  $primary: #2b358d;
  .ajout-inventaire {
    background: $primary;
    border: none;
    padding: 12px 20px;
    color: #fff;
    display: flex;
    align-items: center;
    width: fit-content;
    margin-bottom: 15px;
    svg {
      height: 16px;
      width: 16px;
      margin-right: 8px;
    }
  }
  .add, .inventaire {
    background: #fff;
    margin-top: 20px;

    table {
      width: 100%;
    }
  }
  .petit {
    font-size: 0.85rem;
    margin: 0px;
  }

  td {
    font-size: 0.95rem;
    input {
      width: 80px;
    }
  }

  .inventaireCard {
    background: $primary;
    color: #fff;
    padding: 10px 15px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    h3 {
      font-size: 1.1rem!important;
      margin-bottom: 3px!important;
    }
    p {
      font-size: 0.9rem;
      margin: 0px;
      margin-left: 6px;
    }
  }
  .add, .inventaire {
    height: 500px;
    overflow-y: scroll;
    padding: 15px;
    padding-top: 0px;

  }

  .listeRecapInventaire, .ListeInventaire {
    .entete {
      padding: 15px;
    }
  }

  .last-inventaires {
    a:hover {
      color: #fff;
    }
  }
  .searchInventaire {
    input {
      border-bottom: 1px solid #000;
      margin-right: 10px;
    }
    select {
      margin-right: 10px;
    }
  }
</style>
